const routes = [
  {
    path: "/cava/",
    name: "cava-index",
    component: () => import(/* webpackChunkName: "cava-index" */ "../views/cava/index.vue"),
    meta: { section_name: "cava" },
  },
  {
    path: "/cava/portaria",
    name: "cava-portaria",
    component: () => import(/* webpackChunkName: "cava-portaria" */ "../views/cava/gate-dashboard.vue"),
    meta: { section_name: "cava" },
  },
];
export default routes;
